
import Vue from "vue";

export default Vue.extend( {
  name: "DeleteFormDialog",
  props: {
    dialog: {
      default: false,
      type: Boolean
    },
    formName: {
      default: "",
      type: String
    },
    formId: {
      default: -1,
      type: Number
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
    }
  },
  methods: {
    deleteForm() {
      this.$emit("delete", this.formId);
    },
    closeDialog() {
      this.$emit("close");
    }
  }
})
